module.exports = __webpack_public_path__ + "img/service410.956dce4b.png";